import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from '../../../services/api-base';
import {
  buildGlobalMetadataParams,
  buildGlobalOrderParams,
} from './buildGlobalOrderParams';
import type {
  GlobalFilterMetadataArgs,
  GlobalFilterMetadataResponse,
  GlobalOrderSearchArgs,
  GlobalOrderSearchResponse,
} from '../types/globalOrders.types';

/**
 * Cross-account internal order search (DV-2847/DV-2848). Both endpoints
 * require INTERNAL_ADMIN or INTERNAL_POST_PROCESSING — a 403 is terminal
 * (the route guard should make it unreachable), never a retry.
 *
 * getGlobalFilterMetadata must be fetched LAZILY on drawer open, never on
 * page load — unscoped the backend aggregations are 22–24 s, and the
 * endpoint has no server-side cache. RTK Query's per-arg cache provides the
 * required "cache per (window, statuses)" behavior because those are the
 * query args.
 */
export const globalOrdersApi = createApi({
  reducerPath: 'globalOrdersApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    searchGlobalOrders: builder.query<
      GlobalOrderSearchResponse,
      GlobalOrderSearchArgs
    >({
      query: (args) =>
        `/order-service/api/v1/internal/orders?${buildGlobalOrderParams(args)}`,
    }),

    getGlobalFilterMetadata: builder.query<
      GlobalFilterMetadataResponse,
      GlobalFilterMetadataArgs
    >({
      query: (args) =>
        `/order-service/api/v1/internal/orders/filter-metadata?${buildGlobalMetadataParams(args)}`,
    }),
  }),
});

export const {
  useLazySearchGlobalOrdersQuery,
  useLazyGetGlobalFilterMetadataQuery,
} = globalOrdersApi;
